import * as authUtils from '@flourish-white-label/utility-local-storage';
import { FocusUserCredentials } from './types';

// Focus constants
const focusAuthKey = 'focusUser';

/**
 * Wrapper function for authUtils setUserCredentials
 * @param user
 */
export const setFocusUser = (user: FocusUserCredentials): void => {
  authUtils.setUserCredentials<FocusUserCredentials>(focusAuthKey, user);
};

/**
 * Gets the focus current user credentials.
 * AuthUtils getUserCredentials Wrapper function
 * @returns
 */
export const getFocusUser = (): Partial<FocusUserCredentials> => {
  return authUtils.getUserCredentials<FocusUserCredentials>(focusAuthKey);
};

/**
 *  Sets local storage for Focus User Credential to empty object
 * use a callback to handle navigation or other type of handling.
 * AuthUtils logout Wrapper function
 * @param callback
 */
export const focusLogOut = (callback): void => {
  authUtils.logout(focusAuthKey, callback);
};

/**
 * Wrapper function for AuthUtils isLoggedIn
 * Use to handle authentication navigation
 * @returns boolean
 */
export const isUserLoggedIn = (): boolean => {
  return authUtils.isLoggedIn(focusAuthKey);
};
